import { extend } from 'underscore';
import { jsonTreeParse } from '@bingads-webui/json-tree-parser';


export const formatIMATree = (imaList) => {
  const IMATree = jsonTreeParse(imaList, {
    field: 'Name',
    delimeter: '/',
  });

  // flatten the tree to a list
  const IMATreeItems = [];
  const IMATreeItemIdxMap = {};
  const IdMap = {};
  let idx = 0;
  const flattenTree = (tree, parentValue) => {
    tree.forEach((node) => {
      const {
        id, name, children, data,
      } = node;
      const item = {};

      if (data && data.Id) {
        item.allowedCheck = true;
        IdMap[data.Id] = item;
      }
      if (!IMATreeItemIdxMap[id]) {
        IMATreeItemIdxMap[id] = idx;
        extend(item, {
          value: id,
          name,
          data,
          childIds: children && children.map(child => child.id),
        });
        if (parentValue) {
          item.parentValue = parentValue;
        }
        IMATreeItems.push(item);
        idx += 1;
      }
      if (children) {
        flattenTree(children, id);
      }
    });
  };

  flattenTree(IMATree, null);

  return {
    IMATreeItems, IMATreeItemIdxMap, IdMap,
  };
};

/**
 * For impressions and clicks, 0-2 decimal places
 */
export const impreAndClicksOptions = {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

/**
 * For no decimals, 0 decimal places
 */
export const noDecimalOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const formatBigDecimal = (value, i18n) => {
  if (value > 999999) {
    return i18n.formatDecimal(value, impreAndClicksOptions);
  }
  return i18n.formatDecimal(value, noDecimalOptions);
};
